import React, {useEffect} from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import OrderList from "./OrderList";
import {useModelDispatchers} from "../../../models";

export default function () {
    const {
        getInvoiceTypeDict, getSaleOrderTypeDict, getSalePriceTypeDict,
        getSaleOrderStatusDict,getCustomerTypeDict
    } = useModelDispatchers("cmDict");

    useEffect(() => {
        getInvoiceTypeDict();
        getSaleOrderTypeDict();
        getSalePriceTypeDict();
        getSaleOrderStatusDict();
        getCustomerTypeDict();
    }, []);
    return (
        <>
            <Card
                bordered={true}
                className="margin-top-8"
                style={{display: "flex", minWidth: "1600px"}}
            >
                <div
                    style={{
                        margin: "8px 20px",

                    }}
                >
                    <SearchForm/>
                </div>
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <OrderList/>
            </Card>
        </>
    )
}